import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const SET_CRUMBS = "@common/SET_CRUMBS";
export const SET_HAMBURGER_MENU = "@common/SET_HAMBURGER_MENU";
export const SET_PAGE_TITLE = "@common/SET_PAGE_TITLE";
export const SET_PRESENTATION_MODE = "@common/SET_PRESENTATION_MODE";
export const SET_COLLAPSED_SIDEBAR_MENU = "@common/SET_COLLAPSED_SIDEBAR_MENU";
export const SET_CHAT_HIDDEN = "@common/SET_CHAT_HIDDEN";

export const CommonActions = {
  setChatHidden: (value: boolean) => createAction(SET_CHAT_HIDDEN, { value }),
  setCollapsedSidebarMenu: (isCollapsed: boolean) => createAction(SET_COLLAPSED_SIDEBAR_MENU, { isCollapsed }),
  setCrumbs: (pathname: string) => createAction(SET_CRUMBS, { pathname }),
  setHamburgerMenu: (isOpen: boolean) => createAction(SET_HAMBURGER_MENU, { isOpen }),
  setPageTitle: (value: string) => createAction(SET_PAGE_TITLE, { value }),
  setPresentationMode: (value: boolean) => createAction(SET_PRESENTATION_MODE, { value }),
};

export type CommonActions = ActionsUnion<typeof CommonActions>;
